webpackJsonp([36660496072259],{

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Features = __webpack_require__(20);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _Video = __webpack_require__(15);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Features2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Filtering'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Useful for viewing a subset of data that matches a specific criteria.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visualization'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This video demonstrates what filtering looks like. Screenshots are from the ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'Simply Social'
	      ),
	      ' prototype that ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.invisionapp.com/' },
	        'Invision'
	      ),
	      ' provides you when you sign up for an account.'
	    ),
	    _react2.default.createElement(_Video2.default, { videoId: '2Q8sH_pxYoo' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s say you have an API with a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/posts'
	      ),
	      ' endpoint, and you want to retrieve a list of Posts created by the Author whose id is ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '123'
	      ),
	      '. To do that, pass a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'where'
	      ),
	      ' clause to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'connect'
	      ),
	      ' call like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      @connect(function(getState, props) {\n        return {\n          posts: getState(\'post.find\', {\n            where: {\n              authorId: \'123\'\n            }\n          })\n        };\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Assuming your API server is located at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://api.example.com'
	      ),
	      ', this call will get transformed into the following network request:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      http://api.example.com/posts?authorId=123\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore\'s default behavior is to convert the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'where'
	      ),
	      ' clause into a query string. So if you passed in a second property to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'where'
	      ),
	      ' clause, like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      where: {\n        authorId: \'123\',\n        title: \'Bacon\'\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'It would get converted into this network request:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      http://api.example.com/posts?authorId=123&title=Bacon\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Since it will take time for the network request to complete, let\'s focus on the component next. The component is going to receive a prop named ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'posts'
	      ),
	      ' containing the result of our request for data.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      @connect(function(getState, props) {\n        return {\n          posts: getState(\'post.find\', {\n            where: {\n              authorId: \'123\'\n            }\n          })\n        };\n      })\n      class Component extends React.Component {\n\n        static propTypes = {\n          posts: React.PropTypes.object.isRequired\n        };\n\n        render() {\n          var posts = this.props.posts;\n\n          // todo: render the posts\n        }\n      };\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Since our network request was just sent out, we won\'t have any data yet. So ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'posts'
	      ),
	      ' will look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      posts = {\n        state: \'FETCHING\',\n        data: [],\n        query: { where: { authorId: \'123\' } }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We don\'t have any data to render yet, but the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'query'
	      ),
	      ' field is a stringified JSON that tells us what data we asked for, and the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' field tells us that data is being fetched. So let\'s render a loading message while we\'re waiting for the data to return from the API server.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      @connect(function(getState, props) {\n        return {\n          posts: getState(\'post.find\', {\n            where: {\n              authorId: props.params.authorId\n            }\n          })\n        };\n      })\n      class Component extends React.Component {\n\n        static propTypes = {\n          posts: React.PropTypes.object.isRequired\n        };\n\n        render() {\n          var posts = this.props.posts;\n\n          if (posts.state === PayloadStates.FETCHING) {\n            return (\n              <div>Loading posts...</div>\n            );\n          }\n\n          // todo: render posts\n        }\n      };\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'After a time our network request will come back, the Redux store will be updated, and our component will be rerendered. But this time we\'ll actually have data, so our ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'posts'
	      ),
	      ' will look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      posts = {\n        state: \'RESOLVED\',\n        data: [\n          {\n            id: \'1\',\n            cid: \'c1\',\n            state: \'RESOLVED\',\n            data: {\n              title: \'Bacon is yummy\',\n              authorId: \'123\'\n            }\n          },\n          {\n            id: \'2\',\n            cid: \'c1\',\n            state: \'RESOLVED\',\n            data: {\n              title: \'An ode to Bacon\',\n              authorId: \'123\'\n            }\n          }\n        ],\n        query: { where: { authorId: \'123\' } }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' value of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'RESOLVED'
	      ),
	      ' let\'s you know that nothing is happening; the request has been resolved. And now, our',
	      _react2.default.createElement(
	        'code',
	        null,
	        'data'
	      ),
	      ' property contains an array of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Posts'
	      ),
	      '. So let\'s render that array to display the lists of posts by that author:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      connect(function(getState, props) {\n          return {\n            posts: getState(\'post.find\', {\n              where: {\n                authorId: props.params.authorId\n              }\n            })\n          };\n        })(\n        createReactClass({\n\n          propTypes: {\n            posts: React.PropTypes.object.isRequired\n          },\n\n          render: function() {\n            var posts = this.props.posts;\n\n            if (posts.state === PayloadStates.FETCHING) {\n              return (\n                <div>Loading posts...</div>\n              );\n            }\n\n            return (\n              <ul>\n                {posts.data.map((post) => {\n                  return (\n                    <li key={post.id || post.cid}>\n                      {post.data.title}\n                    </li>\n                  );\n                })}\n              </ul>\n            );\n          }\n        })\n      );\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example Code'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Example code showing how to filter data.'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        connect(function(getState, props) {\n            return {\n              posts: getState(\'post.find\', {\n                where: {\n                  authorId: props.params.authorId\n                }\n              })\n            };\n          })(\n          createReactClass({\n\n            propTypes: {\n              posts: React.PropTypes.object.isRequired\n            },\n\n            renderPost: function(post) {\n              return (\n                <li key={post.id || post.cid}>\n                  {post.data.title}\n                </li>\n              );\n            },\n\n            render: function() {\n              var posts = this.props.posts;\n\n              if (posts.state === PayloadStates.FETCHING) {\n                return (\n                  <div>Loading posts...</div>\n                );\n              }\n\n              return (\n                <ul>\n                  {posts.data.map(this.renderPost)}\n                </ul>\n              );\n            }\n          })\n        );\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        class Component extends React.Component {\n\n          constructor(props) {\n            super(props);\n            this.renderPost = this.renderPost.bind(this);\n          }\n\n          renderPost(post) {\n            return (\n              <li key={post.id || post.cid}>\n                {post.data.title}\n              </li>\n            );\n          }\n\n          render() {\n            var posts = this.props.posts;\n\n            if (posts.state === PayloadStates.FETCHING) {\n              return (\n                <div>Loading posts...</div>\n              );\n            }\n\n            return (\n              <ul>\n                {posts.data.map(this.renderPost)}\n              </ul>\n            );\n          }\n        };\n\n        Component.PropTypes = {\n          posts: React.PropTypes.object.isRequired\n        };\n\n        export default connect(function(getState, props) {\n          return {\n            posts: getState(\'post.find\', {\n              where: {\n                authorId: props.params.authorId\n              }\n            })\n          };\n        })(Component);\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        @connect(function(getState, props) {\n          return {\n            posts: getState(\'post.find\', {\n              where: {\n                authorId: props.params.authorId\n              }\n            })\n          };\n        })\n        class Component extends React.Component {\n\n          static propTypes = {\n            posts: React.PropTypes.object.isRequired\n          };\n\n          constructor(props) {\n            super(props);\n            this.renderPost = this.renderPost.bind(this);\n          }\n\n          renderPost(post) {\n            return (\n              <li key={post.id || post.cid}>\n                {post.data.title}\n              </li>\n            );\n          }\n\n          render() {\n            var posts = this.props.posts;\n\n            if (posts.state === PayloadStates.FETCHING) {\n              return (\n                <div>Loading posts...</div>\n              );\n            }\n\n            return (\n              <ul>\n                {posts.data.map(this.renderPost)}\n              </ul>\n            );\n          }\n        };\n        ' })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-filtering-js-30221918e0ae795147f9.js